// extracted by mini-css-extract-plugin
export default {"root":"Contact_root__VoPWH","form":"Contact_form__I72d1","done":"Contact_done__3ZBs7"};